import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (e) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#06F",
          d: "M8.018 9.595c-.351-.15-.768.105-.768.487v1.957c0 .272.147.522.393.638.749.352 2.476 1.052 4.357 1.052 1.88 0 3.607-.7 4.356-1.052a.7.7 0 0 0 .393-.638v-1.957c0-.382-.417-.637-.768-.487-.867.369-2.367.885-3.982.885-1.614 0-3.114-.516-3.981-.885"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#06F",
          fillRule: "evenodd",
          d: "m6.873 18.977 2.627.002v3.25l5.018-3.246 2.599.002c2.409 0 4.566-1.793 4.753-4.327.17-2.306.178-5.682-.007-7.99-.186-2.312-2.045-4.083-4.314-4.246a80 80 0 0 0-11.08 0c-2.27.163-4.13 1.934-4.315 4.247-.186 2.307-.21 5.683-.04 7.99.188 2.533 2.35 4.318 4.76 4.318M6.701 5.663a77 77 0 0 1 10.615 0 1.39 1.39 0 0 1 1.308 1.266c.172 2.142.163 5.35.005 7.49-.052.707-.672 1.314-1.512 1.314h-2.6L9.5 18.979v-3.246H6.868c-.84 0-1.46-.607-1.512-1.314-.158-2.14-.135-5.348.037-7.49a1.39 1.39 0 0 1 1.308-1.266",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  t as default
};
